export class GroupBreakdown {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dimension",
            "baseName": "dimension",
            "type": "string",
            "format": ""
        },
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<GroupBreakdownEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GroupBreakdown.attributeTypeMap;
    }
    constructor() {
    }
}
